namespace RedBullMOBILE360.Settings {
    export interface ServiceParametersRow {
        Id?: number;
        Name?: string;
        AuthToken?: string;
        OfferId?: string;
    }

    export namespace ServiceParametersRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Settings.ServiceParameters';
        export const deletePermission = 'Settings:ServiceParameters';
        export const insertPermission = 'Settings:ServiceParameters';
        export const readPermission = 'Settings:ServiceParameters';
        export const updatePermission = 'Settings:ServiceParameters';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            AuthToken = "AuthToken",
            OfferId = "OfferId"
        }
    }
}
